import React, { useContext } from 'react';

import { handleAppLinkClick } from 'helpers/mParticle';
import LogoMark from 'components/shared/SVG/LogoMark';

import { CustomerContext } from 'context/customer';

import { GET_THE_APP_URL } from '@chownow/cn-web-utils/paths';

import OutLink from 'components/shared/OutLink/OutLink';

import styles from './AppLinks.module.scss';

export default function AppLinks() {
  const { user } = useContext(CustomerContext);
  return (
    <OutLink
      handleClick={() => {
        handleAppLinkClick({ user, source: 'homepage-footer' });
      }}
      to={GET_THE_APP_URL}
    >
      <button aria-label="Get the App" className={styles.appLinkBtn} type="button">
        <span className={styles.buttonContent}>
          <LogoMark />
          Get the App
        </span>
      </button>
    </OutLink>
  );
}
